import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "fi-icon-custom-inner-arc",
  "use": "fi-icon-custom-inner-arc-usage",
  "viewBox": "0 0 85 85",
  "content": "<symbol viewBox=\"0 0 85 85\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"fi-icon-custom-inner-arc\">\n\t<path d=\"M85 42.5C85 33.9603 82.4274 25.6186 77.6174 18.5622C72.8075 11.5059 65.9834 6.06226 58.0345 2.94082L56.2071 7.59441C63.2209 10.3487 69.2422 15.1519 73.4863 21.3782C77.7305 27.6044 80.0005 34.9648 80.0005 42.5H85Z\" fill=\"#3197EA\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol